
<ion-header>
  <ion-toolbar>
    <ion-title translate="MENUS"></ion-title>
    <ion-buttons slot="end">
      <ion-button class="ion-text-capitalize" (click)="onCloseClick()" translate="CLOSE"></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="menu-list-content">
  <ion-list lines="none">
    <ion-item
      *ngFor="let menu of menus; let i = index"
      button
      class="menu-item"
      (click)="onMenuClick($event, menu, i)"
    >
      <ion-thumbnail slot="start" class="menu-thumbnail">
        <img
          *ngIf="menu.menuIconImage"
          [src]="menu.menuIconImage.url"
          alt="Menu icon"
        />
        <img
          *ngIf="!menu.menuIconImage"
          src="https://ionicframework.com/docs/demos/api/thumbnail/thumbnail.svg"
          alt="Default icon"
        />
      </ion-thumbnail>

      <ion-label class="ion-text-capitalize menu-label">
        <h2 class="menu-title" [innerText]="menu.name"></h2>
        <p class="tags">
          <ion-icon name="pricetags-outline" class="tag-icon"></ion-icon>
          <span [innerText]="menu.tags?.join(', ')"></span>
        </p>
      </ion-label>
    </ion-item>
  </ion-list>
</ion-content>

